import { ElementRef } from '@angular/core';
import { mixinColor } from '../shared/mixinColor';

// Boilerplate for applying mixins to YooButton.
export const _ButtonBase = mixinColor(
  class {
    constructor(public _elementRef: ElementRef) {}
  },
);